import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var BraSizeIcon = function BraSizeIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    enableBackground: "new 0 0 90 90",
    viewBox: "0 0 90 90",
    role: "presentation",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Bra Size Icon"
    }), /*#__PURE__*/_jsxs("g", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [/*#__PURE__*/_jsxs("g", {
        strokeWidth: "5",
        children: [/*#__PURE__*/_jsx("path", {
          d: "m84.5 50.1h-7.6"
        }), /*#__PURE__*/_jsx("path", {
          d: "m82.9 54.6 4.5-4.5-4.6-4.6"
        })]
      }), /*#__PURE__*/_jsx("path", {
        // eslint-disable-next-line max-len
        d: "m68.4 64.2h-47.2l.5-19.1s6.4-.4 6.4-19.3h4.6s-1.1 14.7 9.3 14.7h5.5c10.5 0 9.3-14.7 9.3-14.7h4.6c0 18.9 6.4 19.3 6.4 19.3l.5 19.1h-47",
        strokeWidth: "5.52"
      }), /*#__PURE__*/_jsxs("g", {
        strokeWidth: "5",
        children: [/*#__PURE__*/_jsx("path", {
          d: "m5.5 50.1h7.6"
        }), /*#__PURE__*/_jsx("path", {
          d: "m7.1 54.6-4.5-4.5 4.6-4.6"
        })]
      })]
    })]
  });
};

export default /*#__PURE__*/memo(BraSizeIcon);